import { render, staticRenderFns } from "./ProjectSectionStory.vue?vue&type=template&id=0275db36"
import script from "./ProjectSectionStory.vue?vue&type=script&lang=js"
export * from "./ProjectSectionStory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports